/**
 * Генератор id для блока-таблицы (fkTable): колонки `c…`, строки `r…`.
 *
 * Вынесен из fk-table.tsx, чтобы им пользовались и грид, и чистый модуль
 * импорта (fk-table-import.ts) с ОДНИМ общим счётчиком: два независимых
 * счётчика в одну и ту же миллисекунду выдали бы одинаковые id строк.
 */
let _idc = 0;
export const uid = (p: string): string =>
  `${p}${Date.now().toString(36)}${(_idc++).toString(36)}`;
